import { render } from "./cform3.vue?vue&type=template&id=21d0069c&scoped=true"
import script from "./cform3.vue?vue&type=script&lang=js"
export * from "./cform3.vue?vue&type=script&lang=js"

import "./cform3.vue?vue&type=style&index=0&id=21d0069c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d0069c"]])

export default __exports__